import styles from './DotsLoader.module.scss';

export const DotsLoader = () => {
  return (
    <div className={styles.dots_loader}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
